/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
// import { get } from 'lodash';
import NumberFormat from '../../utils/NumberFormat';

const borderColor = '#3778C2';
const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    borderBottomColor: '#3778C2',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 24,
    fontStyle: 'bold',
  },
  description: {
    width: '85%',
    textAlign: 'left',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
  },
  valor: {
    width: '15%',
    textAlign: 'right',
    paddingRight: 8,
  },
});

function InvoiceTableRowDespesa({ items, comissao }) {
  const rows = items.map((item) => (
    <View style={styles.row} key={item.id.toString()}>
      <Text style={styles.description}>
        {`${item.TipoDespesa.nome} - ${item.descricao} ${
          item.TipoDespesa.flag_combustivel ||
          item.TipoDespesa.flag_motorista ||
          item.TipoDespesa.flag_veiculo ||
          item.TipoDespesa.flag_adm
            ? '*'
            : ''
        }`}
      </Text>
      <Text style={styles.valor}>{NumberFormat(item.valor)}</Text>
    </View>
  ));

  // Adiciona a linha de comissão
  rows.push(
    <View style={styles.row} key="comissao">
      <Text style={styles.description}>Comissao Motorista</Text>
      <Text style={styles.valor}>{NumberFormat(comissao)}</Text>
    </View>
  );

  return <>{rows}</>;
}

export default InvoiceTableRowDespesa;
